export default function(e) {
  if (!e) return;

  return e.graphQLErrors.length
    ? e.graphQLErrors.map((err) => err.message).join(', ')
    : e.message;
}
